import styled from 'styled-components';
import { rem } from 'polished';
import Grid from '@material-ui/core/Grid';

export const Container = styled(Grid)`
  flex: 1;
  padding: ${rem('16px')};
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  /* headerSeparator 50px + breadcrumbs 55px */
  height: calc(100vh - 105px);
  background-color: #f2f3f5;
  
  body[data-theme='dark'] & {
    background-color: transparent;
  }
  min-height: 0;

  @media (max-width: 1199px) {
    overflow-y: auto;
    height: calc(100vh - 105px);
  }
`;

export const DetailHeaderSlot = styled.div`
  flex: 0 0 auto;
  padding-bottom: ${rem('16px')};
`;

/** Products (left) + Activity (right) on desktop; stacked with Activity below <1200px. */
export const DetailBody = styled.div`
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  gap: ${rem('12px')};
  overflow: hidden;

  @media (max-width: 1199px) {
    flex-direction: column;
    overflow: visible;
    flex: 0 0 auto;
    min-height: auto;
  }
`;

export const DetailMain = styled.div`
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 1199px) {
    flex: 0 0 auto;
    overflow: visible;
    min-height: auto;
  }
`;

export const DetailAside = styled.div`
  flex: 0 0 calc(25% + 20px);
  max-width: 340px;
  min-width: ${rem('240px')};
  min-height: 0;
  overflow: hidden;

  @media (max-width: 1199px) {
    flex: 0 0 auto;
    max-width: none;
    width: 100%;
    min-width: 0;
    min-height: ${rem('280px')};
    height: ${rem('320px')};
    overflow: hidden;
  }
`;
